import axios from 'axios';

const DEFAULT_SHOP_OPTIONS = {
  webapiurl: `${window.location.protocol}//${window.location.host}/`,
  fileDomain: 'https://test.nwbbg.com'
};

let shopOptionsPromise = null;

const normalizeBaseUrl = (url) => {
  if (!url) return DEFAULT_SHOP_OPTIONS.webapiurl;
  return url.endsWith('/') ? url : `${url}/`;
};

export const initShopOptions = async () => {
  if (window.ShopOptions) {
    return window.ShopOptions;
  }

  if (!shopOptionsPromise) {
    shopOptionsPromise = axios.get('/config.json', { timeout: 5000 })
      .then(response => {
        const config = response.data || {};
        const options = {
          ...DEFAULT_SHOP_OPTIONS,
          ...config,
          webapiurl: normalizeBaseUrl(config.webapiurl || config.WebApiUrl || config.apiHost || config.ApiHost)
        };

        window.ShopOptions = options;
        return options;
      })
      .catch(() => {
        window.ShopOptions = {
          ...DEFAULT_SHOP_OPTIONS,
          webapiurl: normalizeBaseUrl(DEFAULT_SHOP_OPTIONS.webapiurl)
        };
        return window.ShopOptions;
      });
  }

  return shopOptionsPromise;
};

export const getShopOptions = () => window.ShopOptions || DEFAULT_SHOP_OPTIONS;
